<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Bloques TEP</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">TEP</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Bloques</li>
                  <li class="breadcrumb-item active">
                    Formulario {{ id ? "Editar" : "Crear" }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="col-3 pt-2 pb-2">
                <h5 class="mb-0">Formulario {{ id ? "Editar" : "Crear" }} Bloques</h5>
              </div>
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" id="tab-Principal" data-toggle="tab" href="#Principal"
                    >Principal</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="tab-Geocercas"
                    data-toggle="tab"
                    href="#Geocercas"
                    @click="$refs.TepBloqueGeocerca.getIndex()"
                    v-if="form.id"
                    >Geocercas</a
                  >
                </li>
              </ul>

              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade active show" id="Principal">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="form-group col-md-5">
                        <label>Nombre Bloque</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="form.nombre"
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label>Prefijo</label>
                        <input
                          type="text"
                          maxlength="3"
                          class="form-control form-control-sm"
                          v-model="form.prefijo"
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label>Código</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="form.codigo"
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label>Pais</label>
                        <v-select
                          class="form-control form-control-sm p-0"
                          :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                          v-model="form.pais_id"
                          label="nombre"
                          :options="listasForms.paises"
                          :reduce="(p) => p.id"
                          @input="filtrarDepartamentos()"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label>Departamento</label>
                        <v-select
                          class="form-control form-control-sm p-0"
                          :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                          v-model="form.departamento_id"
                          label="descripcion"
                          :options="listasForms.departamentos"
                          :reduce="(d) => d.id"
                          @input="filtrarCiudades()"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label>Ciudad</label>
                        <v-select
                          class="form-control form-control-sm p-0"
                          :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                          v-model="form.ciudad_id"
                          label="nombre"
                          :options="listasForms.ciudades"
                          :reduce="(c) => c.id"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label>Dirección</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="form.direccion"
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label>Estado</label>
                        <select class="form-control form-control-sm" v-model="form.estado" disabled>
                          <option value="">Seleccione...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-6">
                        <label>Justificación Inactivación</label>
                        <textarea
                          class="form-control form-control-sm"
                          v-model="form.justificacion"
                          disabled
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tab-pane fade" id="Geocercas" v-if="form.id">
                  <div class="card-body">
                    <TepBloqueGeocerca ref="TepBloqueGeocerca" />
                  </div>
                </div>
              </div>

              <div class="card-footer">
                <div class="row">
                  <button class="btn bg-primary col-md-1" @click="save()">
                    <i class="fas fa-paper-plane"></i><br />Guardar
                  </button>
                  <button class="btn bg-secondary col-md-1" @click="back()">
                    <i class="fas fa-reply"></i><br />Volver
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";
import TepBloqueGeocerca from "./TepBloqueGeocerca.vue";

export default {
  name: "TepBloqueForm",
  components: { Loading, vSelect, TepBloqueGeocerca },
  data() {
    return {
      cargando: false,
      id: this.$route?.params?.id ?? null,
      listasIniciales: {
        departamentos: [],
        ciudades: [],
      },
      form: {
        id: null,
        nombre: null,
        prefijo: null,
        codigo: null,
        pais_id: null,
        departamento_id: null,
        ciudad_id: null,
        direccion: null,
        estado: 1,
      },
      listasForms: {
        paises: [],
        departamentos: [],
        ciudades: [],
        estados: [],
      },
    };
  },
  methods: {
    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },
    getPaises() {
      axios.get("/api/admin/paises/lista").then((response) => {
        this.listasForms.paises = response.data;
      });
    },
    getDepartamentos() {
      axios.get("/api/admin/departamentos/lista").then((response) => {
        this.listasIniciales.departamentos = response.data;
      });
    },
    getCiudades() {
      axios.get("/api/admin/ciudades/lista").then((response) => {
        this.listasIniciales.ciudades = response.data;
      });
    },
    filtrarDepartamentos() {
      this.listasForms.departamentos = [];
      this.form.departamento_id = null;
      this.listasForms.ciudades = [];
      this.form.ciudad_id = null;
      if (this.form.pais_id) {
        this.listasForms.departamentos = this.listasIniciales.departamentos.filter(
          (dep) => dep.pais_id === this.form.pais_id
        );
      }
    },
    filtrarCiudades() {
      this.listasForms.ciudades = [];
      this.form.ciudad_id = null;
      if (this.form.departamento_id) {
        this.listasForms.ciudades = this.listasIniciales.ciudades.filter(
          (ciu) => ciu.departamento_id === this.form.departamento_id
        );
      }
    },
    getData() {
      if (!this.id) return;
      this.cargando = true;
      axios
        .get("/api/tep/bloques/show/" + this.id)
        .then((response) => {
          this.form = response.data;
          this.listasForms.departamentos = this.listasIniciales.departamentos.filter(
            (d) => d.id === this.form.departamento_id
          );
          this.listasForms.ciudades = this.listasIniciales.ciudades.filter(
            (c) => c.id === this.form.ciudad_id
          );
          this.cargando = false;
        })
        .catch(() => {
          this.cargando = false;
        });
    },
    save() {
      this.cargando = true;
      axios({
        method: this.id ? "PUT" : "POST",
        url: "/api/tep/bloques",
        data: this.form,
      })
        .then((response) => {
          this.id = response.data.id;
          this.form.id = response.data.id;
          this.$swal({
            icon: "success",
            title: "Bloque guardado exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
          this.getData();
        })
        .catch(() => {
          this.cargando = false;
        });
    },
    back() {
      return this.$router.replace("/tep/General/Bloques");
    },
  },
  mounted() {
    this.getEstados();
    this.getPaises();
    this.getDepartamentos();
    this.getCiudades();
    setTimeout(() => {
      this.getData();
    }, 0);
  },
};
</script>
